<template>
    <v-main>
      <CommunicationReadySendContainer />
    </v-main>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from "vue";
import CommunicationReadySendContainer from '@/container/communication/CommunicationReadySendContainer.vue';

export default defineComponent({
  components: {
    CommunicationReadySendContainer,
  },
});
</script>
